'use client'
import dynamic from 'next/dynamic'

const LazyZohoDeskWidget = dynamic(
  () => import('./DynamicZohoDeskWidgetExport').then((m) => ({ default: m.ZohoDeskWidget })),
  { ssr: false }
)

export default function DeferredZohoDeskWidget() {
  return <LazyZohoDeskWidget />
}
